// Deprecated.

import withMetadataArgument from '../min/exports/withMetadataArgument.js'

import _isPossibleNumber from '../es6/legacy/isPossibleNumber.js'

export function isPossibleNumber() {
	return withMetadataArgument(_isPossibleNumber, arguments)
}



//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/index.es6.exports/isPossibleNumber.js
// module id = 1611
// module chunks = 0